import { useCallback, useState } from "react";
import { t } from "../utils/translate.js";
export function useForgotPasswordForm(api, config) {
    const [state, setState] = useState({
        email: '',
        errors: {},
        isLoading: false,
        isSuccess: false
    });
    const setEmail = useCallback((email)=>{
        setState((prev)=>({
                ...prev,
                email: email.trim(),
                errors: {
                    ...prev.errors,
                    email: undefined
                }
            }));
    }, []);
    const submit = useCallback(async ()=>{
        const errors = {};
        if (!state.email) {
            errors.email = t(config, 'auth.error.requiredField');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)) {
            errors.email = t(config, 'auth.error.invalidEmail');
        }
        if (errors.email) {
            setState((prev)=>({
                    ...prev,
                    errors
                }));
            return;
        }
        setState((prev)=>({
                ...prev,
                isLoading: true,
                errors: {}
            }));
        try {
            const { error } = await api.forgotPassword(state.email);
            if (error) {
                setState((prev)=>({
                        ...prev,
                        isLoading: false,
                        errors: {
                            form: t(config, 'auth.error.networkError')
                        }
                    }));
                return;
            }
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    isSuccess: true
                }));
        } catch  {
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    errors: {
                        form: t(config, 'auth.error.networkError')
                    }
                }));
        }
    }, [
        state.email,
        api,
        config
    ]);
    return {
        email: state.email,
        errors: state.errors,
        isLoading: state.isLoading,
        isSuccess: state.isSuccess,
        setEmail,
        submit
    };
}

//# sourceMappingURL=useForgotPasswordForm.js.map